import styled from "styled-components";

export const PgmLine = styled.hr`
  color: #f5f5f5;
  margin: 10px 1px 10px 0px;
`;

export const TableContainer = styled.div`
  padding: 5px 5px;
  font-size: 12px;
`;

export const Table = styled.table`
  font-size: 12px;
  width: 100%;
`;

export const Tr = styled.tr`
  height: 30px;
`;

export const Th = styled.th`
  background-color: #f3f6ff;
  border: 1px solid #ddd;
  width: 100px;
  line-height: 30px;
  vertical-align: middle;
  text-align: center;
`;

export const Td = styled.td`
  padding-right: 3px;
  text-align: ${(props) => props.textAlign || "right"};
  border: 1px solid #ddd;
  line-height: 30px;
`;

export const SubTitle = styled.div`
  width: ${(props) => props.width || "150px"};
  height: 20px;
  border-radius: 10px;
  padding: 4px;
  color: white;
  text-align: center;
  background-color: #178af4;
  margin: 5px 0px 5px 0px;
`;

export const SumTd = styled(Td)`
  text-align: ${(props) => props.textAlign || "right"};
  background-color: #f9f9f9;
`;

export const AvgTd = styled(Td)`
  text-align: ${(props) => props.textAlign || "right"};
  background-color: #f9f9f9;
`;
